import { NgModule } from "@angular/core";
import { GooglePlaceDirective } from "./ngx-gplaces-autocomplete.directive";

@NgModule({
    declarations: [GooglePlaceDirective],
    exports: [GooglePlaceDirective]
})

export class GooglePlaceModule {
}